export default "__VITE_ASSET__DEcKmUlG__"